import type { ICheckoutContext } from '@/types/context';
import { PaymentMethodEnum } from '@/types/common';
import { buildPaypalPaymentRequest } from '@/utils/paypal';
import type { PayPalPaymentParams } from '@/types/paymentHandlers';
import type { BrainTreePaymentResponse } from '@/types/payment';

export const handlePayPalPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params?: PayPalPaymentParams
): Promise<BrainTreePaymentResponse> => {
  if (!params) {
    throw new Error('PayPal payment requires tokenization data parameter');
  }

  const { tokenizationData } = params;
  const paymentMethodSettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.PAYPAL
  );

  if (!paymentMethodSettings) {
    throw new Error('PayPal payment method settings not found');
  }

  try {
    return (await sendPaymentToServer(
      buildPaypalPaymentRequest(tokenizationData, paymentMethodSettings)
    )) as BrainTreePaymentResponse;
  } catch (e) {
    throw e;
  }
};
